import { Locales } from '@ratehub/base-ui';
import { PAGE_TEMPLATES } from '@ratehub/web-components';

import withFrenchLocale from '../functions/withFrenchLocale';
import createWordpressPageStaticProps from '../functions/createWordpressPageStaticProps';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';
import BLOCK_MAP from '../definitions/TemplateCorporateBlockMap';


const { getStaticPaths, getStaticProps } = createWordpressPageStaticProps({
    locale: Locales.FRENCH,
    fileName: 'wordpressCorporateFR',
    blockMap: BLOCK_MAP,
    template: PAGE_TEMPLATES.corporate,
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withFrenchLocale(page);
export { getStaticPaths, getStaticProps };
